<template>
  <div class="alert-message">
    <div>
      {{ $t("alerts.blockUrlAlert", { domain }) }}
    </div>
    <div class="btn-group">
      <div class="btn btn-cancel"
           @click="$emit('cancel')">
        {{ $t("cancel") }}
      </div>

      <div class="btn btn-confirm"
           @click="$emit('confirm')">
        {{ $t("ok") }}
      </div>
    </div>
  </div>
</template>

<script>
  import { getDomain } from '@/services/utils.js'

  export default {
    props: {
      url: {
        type: String,
        required: true
      }
    },

    computed: {
      domain() {
        return getDomain(this.url)
      }
    }
  }
</script>

<style lang="scss" scoped>
  .domain {
    max-width: 300px;
    display:inline-block;
    text-overflow:ellipsis;
    overflow: hidden;
    white-space:nowrap;
  }

  .alert-message {
    background: color.adjust(map.get($colors, secondary), $lightness: 25%);
    display: flex;
    align-items: center;

    margin-bottom: 15px;
    padding: 0 0 16px 32px;
    font-size: 12px;

    .btn-group {
      display: flex;
      align-items: center;
      margin: 0 10px 0 10px;

      .btn {
        width: 60px;
        height: 25px;

        border-radius: 2px;
        padding: 7px 0;
        margin-right: 12px;

        color: #fff;
        font-weight: bold;
        text-align: center;
        cursor: pointer;
      }

      .btn-confirm {
        background: #22c883;
      }

      .btn-cancel {
        background: #f35f5f;
      }
    }
  }
</style>
